import React from 'react'
import { Router } from 'react-static'
import { hot } from 'react-hot-loader'
import Routes from 'react-static-routes'

import RDWhatsappFormTracker from './components/site/RDWhatsappFormTracker'
import 'containers/app.scss'

const App = () => (
    <Router>
        <div>
            <div className='content'>
                <Routes/>
            </div>
            <RDWhatsappFormTracker />
        </div>
    </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /usr/src/site-blog/src/App.jsx